import * as Yup from 'yup';

export const validationSchemaLead = Yup.object().shape({
  companyName: Yup.string()
    .required('Company Name Is Required')
    .test(
      'is-valid-companyName',
      'Invalid Company Name',
      (value) => !value || /^[a-zA-Z0-9&\-',./ ]+$/.test(value)
    )
    .max(100, 'Company Name must be at most 100 characters'),

  // businessType: Yup.string().required("Business Type is required"),
  leadSourceId: Yup.string().required('Lead Source is required'),

  // email: Yup.string()
  // .nullable()
  // .test(
  //   "is-valid-email",
  //   "Invalid email format",
  //   (value) => {
  //     if (!value) return true; // Allow empty value

  //     // Convert to lowercase for case-insensitive validation
  //     const lowerValue = value.toLowerCase();

  //     // Basic email format check
  //     const emailRegex = /^(?!.*\.\.)(?!.*--)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
  //     if (!emailRegex.test(lowerValue)) return false;

  //     // Valid top-level domains
  //     const validTLDs = [
  //       'com', 'org', 'net', 'edu', 'gov', 'mil', 'int',
  //       'info', 'biz', 'name', 'pro', 'museum', 'coop',
  //       'aero', 'xxx', 'idv', 'mobi', 'asia', 'tel',
  //       'jobs', 'travel', 'in', 'us', 'uk', 'ca', 'au',
  //       'de', 'fr', 'jp', 'io', 'ai', 'co'
  //     ];

  //     // Check if domain extension is valid
  //     const domain = lowerValue.split('@')[1];
  //     const tld = domain.split('.').pop();
  //     return validTLDs.includes(tld);
  //   }
  // ),
  // .required("Email is required"),
  email: Yup.string()
    .nullable()
    .test('is-valid-email', 'Invalid email format', (value) => {
      if (!value) return true; // Allow empty
      return Yup.string().email().isValidSync(value);
    }),

  // secondaryEmail: Yup.string()
  // .nullable()
  // .test(
  //   "is-valid-email",
  //   "Invalid email format",
  //   (value) => {
  //     if (!value) return true; // Allow empty value

  //     // Convert to lowercase for case-insensitive validation
  //     const lowerValue = value.toLowerCase();

  //     // Basic email format check
  //     const emailRegex = /^(?!.*\.\.)(?!.*--)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
  //     if (!emailRegex.test(lowerValue)) return false;

  //     // Valid top-level domains
  //     const validTLDs = [
  //       'com', 'org', 'net', 'edu', 'gov', 'mil', 'int',
  //       'info', 'biz', 'name', 'pro', 'museum', 'coop',
  //       'aero', 'xxx', 'idv', 'mobi', 'asia', 'tel',
  //       'jobs', 'travel', 'in', 'us', 'uk', 'ca', 'au',
  //       'de', 'fr', 'jp', 'io', 'ai', 'co'
  //     ];

  //     // Check if domain extension is valid
  //     const domain = lowerValue.split('@')[1];
  //     const tld = domain.split('.').pop();
  //     return validTLDs.includes(tld);
  //   }
  // ),
  secondaryEmail: Yup.string()
    .nullable()
    .test('is-valid-email', 'Invalid email format', (value) => {
      if (!value) return true; // Allow empty
      return Yup.string().email().isValidSync(value);
    }),

  sourceName: Yup.string().required('Source Name is required'),

  // otherSourceName: Yup.string()
  //   .nullable(),

  firstName: Yup.string()
    .nullable()
    .trim()
    .max(50, 'First Name must not exceed 50 characters')
    .test(
      'valid-format',
      'Please enter valid name',
      (value) =>
        !value ||
        (/^[A-Za-z0-9\s\-']+$/.test(value) && // Only alphabets, numbers and allowed special chars
          !/(\s{2,}|-{2,}|'{2,})/.test(value) && // No consecutive spaces or special chars
          !/^[-'\s]|[-'\s]$/.test(value)) // No leading/trailing special chars
    ),

  middleName: Yup.string()
    .nullable()
    .trim()
    .max(50, 'Middle Name must not exceed 50 characters')
    .test('valid-format', 'Please enter valid name', (value) => {
      if (!value) return true; // Allow empty value

      // Case 1: Single initial with dot (e.g., "L.")
      if (/^[A-Z]\.$/.test(value)) return true;

      // Case 2: Regular name (e.g., "Smith")
      if (/^[A-Za-z]+$/.test(value)) return true;

      return false;
    }),

  lastName: Yup.string()
    .required('Last Name is required')
    .trim()
    .max(50, 'Last Name must not exceed 50 characters')
    .test(
      'valid-format',
      'Please enter valid name',
      (value) =>
        !value ||
        (/^[A-Za-z0-9\s\-']+$/.test(value) && // Only alphabets, numbers and allowed special chars
          !/(\s{2,}|-{2,}|'{2,})/.test(value) && // No consecutive spaces or special chars
          !/^[-'\s]|[-'\s]$/.test(value)) // No leading/trailing special chars
    ),

  title: Yup.string()
    .nullable()
    .trim() // Trim leading and trailing spaces
    .max(100, 'Title cannot exceed 100 characters')
    .test('is-valid-title', 'Title contains invalid characters or formatting', (value) => {
      if (!value) return true; // Allow blank input
      // Ensure only valid characters and no consecutive spaces or special characters
      return /^[A-Za-z0-9\s-'.,/&]+$/.test(value) && !/( {2,}|[-'.,/&]{2,})/.test(value);
    }),

  street: Yup.string()
    .nullable()
    .trim() // Automatically trim leading and trailing spaces
    .max(100, 'Street cannot exceed 100 characters.')
    .test('valid-characters', 'Invalid characters in street.', (value) => {
      if (!value) return true; // Allow blank input
      // Regex to validate allowed characters and ensure no consecutive special characters or spaces
      return /^[A-Za-z0-9 ,.#/'-]+$/.test(value) && !/( {2,}|[,.#/'-]{2,})/.test(value);
    }),

  city: Yup.string()
    .nullable()
    .trim() // Automatically trim leading and trailing spaces
    .max(50, 'City cannot exceed 50 characters.')
    .test('valid-characters', 'Please enter valid city', (value) => {
      if (!value) return true; // Allow blank input
      return /^[A-Za-z\s'-.]+$/.test(value);
    }),

  state: Yup.string()
    .nullable()
    .trim() // Automatically trim leading and trailing spaces
    .max(50, 'State cannot exceed 50 characters.')
    .test('valid-characters', 'Please enter valid state.', (value) => {
      if (!value) return true; // Allow blank input
      return /^[A-Za-z\s-]+$/.test(value);
    }),

  country: Yup.string()
    .nullable()
    .trim()
    .test('valid-country', 'Country should only contain alphabets and hyphens', (value) => {
      if (!value) return true; // Allow blank input
      // Allow alphabets, spaces and single hyphens
      return (
        /^[A-Za-z\s-]+$/.test(value) && // Only alphabets, spaces and hyphens
        !/--/.test(value) && // No consecutive hyphens
        !/^-|-$/.test(value)
      ); // No leading/trailing hyphens
    }),

  companyLinkedIn: Yup.string()
    .trim()
    .nullable()
    .test('is-valid-linkedin', 'LinkedIn URL must be a valid LinkedIn profile URL', (value) => {
      if (!value) return true;
      // Convert to lowercase for case-insensitive validation
      const lowerValue = value.toLowerCase();
      return /^(https?:\/\/)?(www\.)?linkedin\.com\/[\w@.-]+.*$/.test(lowerValue);
    }),

  website: Yup.string()
    .trim()
    .max(200, 'URL cannot exceed 200 characters')
    .nullable()
    .test('is-valid-url', 'Invalid website format', (value) => {
      if (!value) return true; // Skip validation if value is empty

      // Convert to lowercase for case-insensitive validation
      const lowerValue = value.toLowerCase();

      // Basic URL format check
      const urlRegex = /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/.*)?$/;
      if (!urlRegex.test(lowerValue)) return false;

      // Valid top-level domains
      const validTLDs = [
        'com',
        'org',
        'net',
        'edu',
        'gov',
        'mil',
        'int',
        'info',
        'biz',
        'name',
        'pro',
        'museum',
        'coop',
        'aero',
        'xxx',
        'idv',
        'mobi',
        'asia',
        'tel',
        'jobs',
        'travel',
        'in',
        'us',
        'uk',
        'ca',
        'au',
        'de',
        'fr',
        'jp',
        'io',
        'ai',
        'co',
      ];

      // Extract domain and check TLD
      const domain = lowerValue.replace(/^(https?:\/\/)?(www\.)?/, '');
      const tld = domain.split('/')[0].split('.').pop();
      return validTLDs.includes(tld);
    }),

  contactLinkedIn: Yup.string()
    .nullable()
    .test('is-valid-url', 'Invalid URL format', (value) => {
      if (!value) return true;
      // Convert to lowercase for case-insensitive validation
      const lowerValue = value.toLowerCase();
      return (
        /^(https?:\/\/)?(www\.|m\.)?linkedin\.com\/(in\/[a-zA-Z0-9_-]+)(\/.*)?$/.test(lowerValue) &&
        value.length >= 5 &&
        value.length <= 100
      );
    }),
  // .required('Contact LinkedIn URL is required'),
  industryId: Yup.string().required('Industry is required'),
  accessLevel: Yup.string().nullable(),
  geoScopeNodeId: Yup.number().typeError('GeographyNode is required').required('GeographyNode is required'),
  orgScopeNodeId: Yup.number().typeError('OrgUnitNode is required').required('OrgUnitNode is required'),
  // phone: Yup.string()
  // .nullable()
  // .trim()
  // .test(
  //   "is-valid-phone",
  //   "Phone number must be 7-15 digits with optional separators (+, -, (, ), space)",
  //   (value) => {
  //     if (!value) return true; // Allow empty value

  //     // Remove all allowed separators to count digits
  //     const digitsOnly = value.replace(/[\s+\-()]/g, '');
  //     if (digitsOnly.length < 7 || digitsOnly.length > 15) return false;

  //     // Check for valid characters and format
  //     return /^[0-9\s+\-()]+$/.test(value) && // Only numbers and allowed separators
  //            !/[\s+\-()]{2,}/.test(value); // No consecutive separators
  //   }
  // ),

  phone: Yup.string()
    .nullable()
    .trim()
    .test(
      'is-valid-phone',
      'Phone number must be 7-15 digits with optional separators (+, -, (, ), space)',
      (value) => {
        if (!value) return true; // Allow empty

        const digitsOnly = value.replace(/\D/g, '');
        if (digitsOnly.length < 7 || digitsOnly.length > 15) return false;

        // Check allowed characters only
        if (!/^[0-9+\-\s()]+$/.test(value)) return false;

        // Reject if two special characters (non-digits) come back-to-back (excluding spaces)
        if (/(?! )[\+\-\(\)]{2,}/.test(value)) return false;

        return true;
      }
    ),

  // .required('Phone number is required'),
  directPhone: Yup.string()
    // .nullable()
    // .trim()
    // .test(
    //   "is-valid-phone",
    //   "Phone number must be 7-15 digits with optional separators (+, -, (, ), space)",
    //   (value) => {
    //     if (!value) return true; // Allow empty value

    //     // Remove all allowed separators to count digits
    //     const digitsOnly = value.replace(/[\s+\-()]/g, '');
    //     if (digitsOnly.length < 7 || digitsOnly.length > 15) return false;

    //     // Check for valid characters and format
    //     return /^[0-9\s+\-()]+$/.test(value) && // Only numbers and allowed separators
    //            !/[\s+\-()]{2,}/.test(value); // No consecutive separators
    //   }
    // ),
    .nullable()
    .trim()
    .test(
      'is-valid-phone',
      'Phone number must be 7-15 digits with optional separators (+, -, (, ), space)',
      (value) => {
        if (!value) return true; // Allow empty

        const digitsOnly = value.replace(/\D/g, '');
        if (digitsOnly.length < 7 || digitsOnly.length > 15) return false;

        // Check allowed characters only
        if (!/^[0-9+\-\s()]+$/.test(value)) return false;

        // Reject if two special characters (non-digits) come back-to-back (excluding spaces)
        if (/(?! )[\+\-\(\)]{2,}/.test(value)) return false;

        return true;
      }
    ),
  // .required('Direct phone number is required'),
  mobile: Yup.string()
    // .nullable()
    // .trim()
    // .test(
    //   "is-valid-phone",
    //   "Phone number must be 7-15 digits with optional separators (+, -, (, ), space)",
    //   (value) => {
    //     if (!value) return true; // Allow empty value

    //     // Remove all allowed separators to count digits
    //     const digitsOnly = value.replace(/[\s+\-()]/g, '');
    //     if (digitsOnly.length < 7 || digitsOnly.length > 15) return false;

    //     // Check for valid characters and format
    //     return /^[0-9\s+\-()]+$/.test(value) && // Only numbers and allowed separators
    //            !/[\s+\-()]{2,}/.test(value); // No consecutive separators
    //   }
    // ),
    .nullable()
    .trim()
    .test(
      'is-valid-phone',
      'Phone number must be 7-15 digits with optional separators (+, -, (, ), space)',
      (value) => {
        if (!value) return true; // Allow empty

        const digitsOnly = value.replace(/\D/g, '');
        if (digitsOnly.length < 7 || digitsOnly.length > 15) return false;

        // Check allowed characters only
        if (!/^[0-9+\-\s()]+$/.test(value)) return false;

        // Reject if two special characters (non-digits) come back-to-back (excluding spaces)
        if (/(?! )[\+\-\(\)]{2,}/.test(value)) return false;

        return true;
      }
    ),
  // .required('Mobile number is required'),

  alternatePhone: Yup.string()
    // .nullable()
    // .trim()
    // .test(
    //   "is-valid-phone",
    //   "Phone number must be 7-15 digits with optional separators (+, -, (, ), space)",
    //   (value) => {
    //     if (!value) return true; // Allow empty value

    //     // Remove all allowed separators to count digits
    //     const digitsOnly = value.replace(/[\s+\-()]/g, '');
    //     if (digitsOnly.length < 7 || digitsOnly.length > 15) return false;

    //     // Check for valid characters and format
    //     return /^[0-9\s+\-()]+$/.test(value) && // Only numbers and allowed separators
    //            !/[\s+\-()]{2,}/.test(value); // No consecutive separators
    //   }
    // ),
    .nullable()
    .trim()
    .test(
      'is-valid-phone',
      'Phone number must be 7-15 digits with optional separators (+, -, (, ), space)',
      (value) => {
        if (!value) return true; // Allow empty

        const digitsOnly = value.replace(/\D/g, '');
        if (digitsOnly.length < 7 || digitsOnly.length > 15) return false;

        // Check allowed characters only
        if (!/^[0-9+\-\s()]+$/.test(value)) return false;

        // Reject if two special characters (non-digits) come back-to-back (excluding spaces)
        if (/(?! )[\+\-\(\)]{2,}/.test(value)) return false;

        return true;
      }
    ),

  // zipCode: Yup.string()
  // .nullable()
  // .trim() // Automatically trim leading and trailing spaces
  // .test("is-valid-zip-code", "ZIP code is invalid.", (value) => {
  //   if (!value) return true; // Allow blank input
  //   // Validate numeric values with an optional hyphen
  //   return /^[0-9-]+$/.test(value) && !/--/.test(value) && /^[0-9]{5}(-[0-9]{4})?$/.test(value);
  // }),
  zipCode: Yup.string()
    .nullable()
    .trim()
    .test(
      'is-valid-zip-code',
      'ZIP code must be 3-10 characters with only letters, numbers and hyphens',
      (value) => {
        if (!value) return true; // Allow empty value

        // Check for valid characters and length
        return (
          /^[A-Za-z0-9-]{3,10}$/.test(value) && // Only letters, numbers, hyphen
          !/--/.test(value)
        ); // No consecutive hyphens
      }
    ),

  // ownerId: Yup.string().required("Lead Owner is required"),
  // salutationId: Yup.string().required("Salutation is required")
  businessType: Yup.string().nullable(),

  lineOfBusiness: Yup.string().nullable(),

  annualRevenue: Yup.string()
    .nullable()
    .test({
      name: 'is-valid-amount',
      message: 'Enter a valid amount',
      test: (value) => {
        if (!value) return true; // Allow empty value

        // Check if value contains only numbers and at most one decimal point
        const hasOnlyValidChars = /^[0-9.]+$/.test(value);
        const decimalPoints = (value.match(/\./g) || []).length;

        return hasOnlyValidChars && decimalPoints <= 1;
      },
    })
    .test({
      name: 'no-leading-decimal',
      message: 'Enter a valid amount',
      test: (value) => {
        if (!value) return true;
        return !value.startsWith('.');
      },
    })
    .test({
      name: 'decimal-places',
      message: 'Enter a valid amount',
      test: (value) => {
        if (!value) return true;
        const parts = value.split('.');
        return parts.length === 1 || parts[1].length <= 2;
      },
    }),

  writtenPremium: Yup.string()
    .nullable()
    .test({
      name: 'is-valid-amount',
      message: 'Enter a valid amount',
      test: (value) => {
        if (!value) return true; // Allow empty value

        // Check if value contains only numbers and at most one decimal point
        const hasOnlyValidChars = /^[0-9.]+$/.test(value);
        const decimalPoints = (value.match(/\./g) || []).length;

        return hasOnlyValidChars && decimalPoints <= 1;
      },
    })
    .test({
      name: 'no-leading-decimal',
      message: 'Enter a valid amount',
      test: (value) => {
        if (!value) return true;
        return !value.startsWith('.');
      },
    })
    .test({
      name: 'decimal-places',
      message: 'Enter a valid amount',
      test: (value) => {
        if (!value) return true;
        const parts = value.split('.');
        return parts.length === 1 || parts[1].length <= 2;
      },
    }),
});
